import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { InputMain, ModalActions, ModalHeader } from "components";
import {
  charityActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions,
} from "store";
import {
  EmailValidator,
  FindError,
  FindSuccess,
  Notify,
  SaveParams,
  useModal,
} from "utils";
import { CREATE_ACTION_TYPE } from "./fragments";

export const CreateCharity = () => {
  const dispatch = useDispatch();
  const { close } = useModal();
  const { handleSubmit, control, setError } = useForm({});
  const success = FindSuccess(CREATE_ACTION_TYPE);
  const backError = FindError(CREATE_ACTION_TYPE);
  const navigator = useNavigate();
  const location = useLocation();
  const info = location?.state;

  useEffect(() => {
    if (success?.type === CREATE_ACTION_TYPE) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(CREATE_ACTION_TYPE));
      close();
      SaveParams(location?.pathname, navigator, { ...info });
    }
  }, [success]);

  useEffect(() => {
    if (backError?.error) {
      if (backError?.error === "Failed to create charity") {
        Notify("Failed to create charity", { type: "error" });
      }

      if (
        backError?.error === "User with this email already exists" ||
        backError?.error === "User already invited"
      ) {
        setError("email", {
          message: "User with this email already exists",
        });
      }

      dispatch(httpRequestsOnErrorsActions.removeError(CREATE_ACTION_TYPE));
    }
  }, [backError]);

  const onSubmit = (data) => {
    const params = {
      ...data,
    };
    dispatch(charityActions.createCharity(params));
  };

  return (
    <div className="create-charity-modal">
      <ModalHeader title="Create Charity" />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-form-box">
          <InputMain
            name="name"
            type="text"
            control={control}
            placeholder="Enter Charity Name"
            labelHeader="Charity Name"
            rules={{
              required: "This Field is required",
            }}
          />
          <InputMain
            name="email"
            type="email"
            control={control}
            placeholder="example@gmail.com"
            labelHeader="Email"
            rules={{
              required: "This Field is required",
              pattern: {
                value: EmailValidator,
                message: "Must be valid email",
              },
            }}
          />
        </div>
        <ModalActions
          type="submit"
          loadAction={CREATE_ACTION_TYPE}
          saveTitle="Save"
        />
      </form>
    </div>
  );
};
